"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BronsonWhiteBadge = void 0;
const React = require("react");
const white_badge_style_1 = require("./white-badge-style");
const BronsonWhiteBadge = (_a) => {
    var { closable = true, onClose = () => { } } = _a, props = __rest(_a, ["closable", "onClose"]);
    return (React.createElement("div", { id: `white-badge-${props.elementId || 'bronson'}`, className: `o-layout__item u-1/1@s ${props.className}` },
        React.createElement("div", { style: white_badge_style_1.badge, className: 'u-m-xxsmall' },
            React.createElement("div", { style: white_badge_style_1.badgeContent }, props.children),
            React.createElement("div", { style: white_badge_style_1.closeWrapper },
                React.createElement("div", { id: `white-badge-control-close-${props.elementId || 'bronson'}`, className: 'c-link u-mr c-download-link', onClick: () => {
                        onClose();
                    } }, closable && (React.createElement(React.Fragment, null,
                    React.createElement("i", { style: white_badge_style_1.closeIconCircle, className: 'c-link__icon c-icon c-icon--small c-icon--[semantic-close]' }),
                    React.createElement("span", { style: white_badge_style_1.closeIconSpan, className: 'c-link__body' },
                        React.createElement("span", { className: 'c-link__effect' })))))))));
};
exports.BronsonWhiteBadge = BronsonWhiteBadge;
